module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "gamble_aware.0ac12347.webp";